/* istanbul ignore file */
import {createAxiosInstance} from "@next/axios"
import env from "../../config/env"

const {PORT} = env

const axiosInstance = createAxiosInstance({
    PORT,
    REACT_APP_APP_URL: `http://localhost:${PORT}`,
})

export default axiosInstance
